export interface IQaRegistrationRegistrationStep {
    registrationStepId: number;
    registrationStepName: string;
}